export const environment = {
  production: false,
  apiBaseUrl: 'https://ghipapiprod.indusindinsurance.co.in/api/v1/',
  envName: 'production',
  cookieDomain: '',
  sentryIOUrl: '',
  mixpanelToken: '',
  siteVersion: '%VERSION%',
  loginToken: 'sieWMsDZ1BOamVf9BAdhkVlzoh4qGWQe',
  authority: 'https://login.indusindinsurance.co.in/',
  scopes: 'openid profile GhipApi',
  // redirectUri: 'https://preenroll.reliancegeneral.co.in/auth-callback/',
  // post_logout_redirect_uri: 'https://preenroll.reliancegeneral.co.in/',
  redirectUri: 'https://customer.indusindinsurance.co.in/auth-callback/',
  post_logout_redirect_uri: 'https://customer.indusindinsurance.co.in/',
  client: 'Ghip',
};
